import api from './api';
import types from './mutation-types';
import _ from 'lodash';

export default {
	/**commit mutations*/
	//메인화면 초기화
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	//팝업화면 초기화
	setPopupStateInit_({ commit }) {
		commit(types.POPUP_STATE_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setSelectedParam_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
		//commit(types.SELECTED_PARAM, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	//form영역에서 입력한 항목을 formInfo store에 세팅
	onChangeParam_({ commit }, payload) {
		commit(types.POPUP_SET_FORM, payload);
	},
	/**call API */
	async getCommCodes_({ commit, rootState }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType, rootState['commonStore'].user.plantCd);
			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	/**한번에 공통 코드 부르기 */
	async getCommCodesOnce_({ commit }) {
		try {
			function sortCommCdList(commCd, val) {
				const key = _.camelCase(commCd) + 'CdList';
				const list = [];
				val.length && val.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				commit(types.DEFAULT_ASSIGN, { key, value: list });
			}
			const { header, body } = await api.getCommCodesOnce();
			if (header.code === 0) {
				for (const [key, val] of Object.entries(body)) {
					sortCommCdList(key, val);
				}
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	// 측정기 교정업체 셀렉트박스 조회
	async getMmcInstList_({ commit }) {
		try {
			const { header, body } = await api.getMmcInstList();
			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key: 'calInstCdList', value: body });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	// 조회버튼 클릭시
	async getMesInfoList_({ commit, state }) {
		try {
			const { searchParams, pagingInfo } = state;
			const data = await api.getMesInfoList({ searchParams, pagingInfo });
			if (data.header.code === 0) {
				const { pagingInfo, resultList, ubiTarget } = data.body;
				data.header = { ...data.header, ubiTarget };
				commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'resultList', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			throw error.header || error;
		}
	},
	// 팝업에서 조회버튼 클릭시
	async getMesInfoOne_({ commit, dispatch, rootGetters }, schMesEqipNo) {
		try {
			const data = await api.getMesInfoOne(schMesEqipNo);
			if (data.header.code === 0) {
				const { resultList } = data.body;
				if (resultList.length) commit(types.DEFAULT_ASSIGN, { key: 'popupData', value: resultList[0] });
				else {
					dispatch('setPopupStateInit_');
					return {
						code: 2,
						message: rootGetters['commonStore/getMessage_']('QWCC001789'), //결과가 없습니다.
						schMesEqipNo
					};
				}
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			throw error.header || error;
		}
	},
	//저장버튼 클릭시
	async saveMesInfo_({ commit, state }, popupData) {
		try {
			const { header, body } = await api.saveMesInfo(popupData);
			return { header, body };
		} catch (error) {
			throw error.header || error;
		}
	},
	async reMesInfo_({ commit, state }, popupData) {
		try {
			const { header, body } = await api.reMesInfo(popupData);
			return { header, body };
		} catch (error) {
			throw error.header || error;
		}
	},
	async deMesInfo_({ commit, state }, popupData) {
		try {
			const { header, body } = await api.deMesInfo(popupData);
			return { header, body };
		} catch (error) {
			throw error.header || error;
		}
	},
	//가동상태 변경 저장 클릭시
	async savePrbmMesInfo_(store, prbm) {
		try {
			const { header } = await api.savePrbmMesInfo(prbm);
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	// 교정이력 조회
	async getHistoryList_({ commit, state }, mesEqipNo) {
		try {
			const { hisPagingInfo1 } = state;
			const data = await api.getHistoryList(mesEqipNo, { currentPage: hisPagingInfo1.currentPage, pageUnit: hisPagingInfo1.pageUnit });
			if (data.header.code === 0) {
				const { pagingInfo, resultList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'hisPagingInfo1', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'hisResultList1', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			throw error.header || error;
		}
	},
	// 이상이력 조회
	async getHisPrbmList_({ commit, state }, mesEqipNo) {
		try {
			const { hisPagingInfo2 } = state;
			const data = await api.getHisPrbmList(mesEqipNo, { currentPage: hisPagingInfo2.currentPage, pageUnit: hisPagingInfo2.pageUnit });
			if (data.header.code === 0) {
				const { pagingInfo, resultList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'hisPagingInfo2', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'hisResultList2', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async fileDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			throw error.header || error;
		}
	},
	// 차기 교정일 저장
	async setCalStCdUpdate_({ commit }, param) {
		try {
			const data = await api.postCalStCdUpdate(param);
			return data.header;
		} catch (error) {
			throw error.header || error;
		}
	}
};
